import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/provider-managers'
const API_URL_EMPLOYEE =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/employee-users'

class AdminApi {
  getList(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  getProfile() {
    return axios.get(process.env.VUE_APP_BASE_API_URL + '/api/v1/security/_profile', { headers: authHeader() })
  }

  updateProfile(data) {
    return axios.put(process.env.VUE_APP_BASE_API_URL + '/api/v1/security/_profile-update', data, { headers: authHeader() })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createAdmin(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  editAdmin(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }

  editAdminAccess(uuid, data) {
    return axios.put(API_URL + '/' + uuid + '/_access', data, { headers: authHeader() })
  }

  createEmployeeAccess(data) {
    return axios.post(API_URL_EMPLOYEE, data, { headers: authHeader() })
  }

  deleteEmployeeAccess(uuid) {
    return axios.delete(API_URL_EMPLOYEE + '/' + uuid, {
      headers: authHeader()
    })
  }
}

export default new AdminApi()
